export const GET_HOME_SLIDERS = 'sliders/homeSliders/get';
export const GET_HOME_SLIDER_BY_ID = 'sliders/homeSliderById/get';


